<template>
  <div class="columns is-multiline">
    <Sub title="Accumulo" tag="AC" v-model:elements="implant.accumulations" v-slot="slotProps" :codes="implant.codes">
      <Accumulation :element="slotProps.element" />
    </Sub>
  </div>
</template>
  
<script>
import Accumulation from './_8-accumulation/accumulation'

export default {
  components: {
    Accumulation
  },

  props: {
    implant: Object
  },
  emits: ['update:implant']
}
</script>